import React, { useState, useCallback, useEffect } from "react";
import Popover from "@mlb/react-patterns/components/Popover/popover";
import {
  CameraOptionsPopoverWrapper,
  PlaybackButton,
} from "../fieldvision.style";
import {
  FieldVisionController,
  PublicCameraConfig,
} from "../../FieldVisionController";
import {
  PopoverPlacement,
  ShowOnEvent,
} from "@mlb/react-patterns/components/Popover/popover.types";
import Icon from "@mlb/react-patterns/components/Icon/icon";
import { IconSizes } from "@mlb/react-patterns/components/Icon/icon.types";
import debounce from "lodash/debounce";

interface CameraOptionsCycleProps {
  controller: FieldVisionController;
}

const CameraOptionsCycle = (props: CameraOptionsCycleProps) => {
  const { controller } = props;
  const [title, setTitle] = useState<string>("-");
  const [isCamToastOpen, setIsCamToastOpen] = useState(false);
  const debouncedToastClose = useCallback(
    debounce(() => {
      setIsCamToastOpen(false);
    }, 2000),
    []
  );

  useEffect(() => {
    controller.addCameraModeSubscriber(
      "cameraOptionsCycle",
      (config: PublicCameraConfig) => {
        setTitle((title) => {
          if (config.title !== title) {
            setIsCamToastOpen(true);
            debouncedToastClose();
          }
          return config.title;
        });
      }
    );
  }, []);

  return (
    <CameraOptionsPopoverWrapper className="button-wrapper">
      <Popover
        theme={{}}
        placement={PopoverPlacement.TOP_END}
        popoverContent={
          <div style={{ color: "#fff", padding: "16px" }}>{title}</div>
        }
        popoverOffset={[39, 20]}
        showOnEvent={ShowOnEvent.CLICK}
        preventOverflow={false}
        closeOnPopperClick={false}
        isOpen={isCamToastOpen}
      >
        <PlaybackButton
          id="fv-camera-cycle-button"
          title="camera-options"
          onClick={() => {
            controller.nextCameraMode();
          }}
        >
          <Icon name="camera-fv" size={IconSizes.LG} fill="#fff" />
        </PlaybackButton>
      </Popover>
    </CameraOptionsPopoverWrapper>
  );
};

export default CameraOptionsCycle;
